import { ofType, combineEpics } from "redux-observable";
import { tap, ignoreElements } from "rxjs/operators";
import RouteUpdateConstants from "@ane/core/lib/services/syncUrlAndStore/RouteUpdateConstants";
import Logger from "@ane/core/lib/services/logging/Logger";
import { PLTTelemetryEventNames } from "../../telemetry/PLTTelemetryEventNames.js";
const routeChange = (action$) => {
  return action$.pipe(
    ofType(RouteUpdateConstants.ROUTE_UPDATE),
    tap((action) => {
      const payload = action.payload;
      const nameAndLoaction = {
        name: payload.pathname,
        location: payload
      };
      Logger.routeView(nameAndLoaction);
      Logger.trackMetric({
        name: PLTTelemetryEventNames.PLT_RouteView,
        average: 0,
        properties: nameAndLoaction
      });
    }),
    // ignoreElements: This epic only needs to log LOAD_START, so we don't need to pipe any additional actions
    ignoreElements()
  );
};
const CoreEpics = combineEpics(routeChange);
export {
  CoreEpics as default,
  routeChange
};
//# sourceMappingURL=CoreEpics.js.map
